import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom'
import MediaQuery from 'react-responsive';
import { saveActivity } from '../../common/commonService.js'
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import './Header.css'
import * as actions from '../../store/actions/index';
import moment from 'moment';
import { connect } from 'react-redux';
import DownloadHandHistory from '../../components/DownloadHandHistory/DownloadHandHistory';
import queryString from 'query-string';
import MyGameMessenger from '../../components/MyGameMessenger';
import i18next from 'i18next'
// import * as actions from '../../store/actions/index';
import { actionTypes } from 'redux-form';
import { getColor, getDarkTextColor, getHoverColor, getImage, getTextColor } from '../../common/ThemeService.js';
import MyGameMessenger2 from '../../components/MyGameMessanger2';
import { DispatcherFunction } from 'mygame-components';
import { partyBrands } from '../../common/config.js';
// import MyGameMessenger from '../../components/MyGameMessenger';
let PartyPokerIcon = "/images/logo/PartyPoker%402x.png"
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      access: JSON.parse(localStorage.getItem('userRole')),
      loginRedirect: false,
      userType: localStorage.getItem('loggedInType'),
      location: '/',
      open: false,
      wnd: null,
      openMessenger: false,
      lang:"",
      disableLangauge:"off",
      fromClient:JSON.parse(localStorage.getItem('fromClient',false)),
      loggedInType: localStorage.getItem('loggedInType')
    };

  }
  componentDidMount = () => {
    if(localStorage.getItem("loggedInType") === "Danskespil"){
      PartyPokerIcon = "/images/logo/Danskespil%402x.png"
    }
    localStorage.setItem('new_language', "en");
    this.changei8next("en");
    console.log("local disableLangauge",localStorage.getItem("disableLangauge"));
    this.setState({disableLangauge:localStorage.getItem("disableLangauge") ? localStorage.getItem("disableLangauge") : "off"})
  }

  handleToggle = () => {
    this.setState({ open: true });
  }

  handleClose = () => { this.setState({ open: false }); }

  resetStore = async () => {
    window.location = "/myGameLogut";
  }
  
  logout = (loginPath) => {
    if (loginPath === 'MyGame') this.setState({ location: '/mygamelogin' })
    else if (loginPath === 'PartyPoker') this.setState({ location: '/' })
    else if (loginPath === 'Danskespil') this.setState({ location: '/loggedOut' })
    else this.setState({location:'/brandLogin'})
    this.setState({ loginRedirect: true })
  }
 
  MenuLink = props => (
    <Link
      to={props.linkTo}
      style={{
        textAlign: 'left',
        textDecoration: 'none',
        borderBottomStyle: 'double',
        borderBottomColor: 'white',
        borderBottomWidth: '5px'
      }}
      onClick={props.onLinkClick ? props.onLinkClick : () => { }}
    >
      <MenuItem onClick={()=>{this.handleClose()}}>
        <span className='menuText' >
          {props.label}
        </span>
      </MenuItem>
    </Link>
  )
  getDrawer = (props) => {
    return (
      <Drawer
        containerStyle={{ backgroundColor: '#222222' }}
        width={props.width}
        open={this.state.open}
        openSecondary={true}
        docked={false}
        onRequestChange={(open) => this.setState({ open })}
      >
        <MediaQuery maxWidth={991}>
          <span className='header-cross-bar' onClick={(open) => this.setState({ open: false })}>
            <i className="fa fa-close" style={{ color: 'white', float: 'right', marginRight: '57%' }}></i>
          </span>
        </MediaQuery>
        <div style={{ marginTop: '66px' }}>
          {this.state.access.indexOf('SYS_ADMIN') != -1 ?
            <this.MenuLink linkTo="/pokerWatmyReportCardch" label="Poker Watch" />: (this.state.access.indexOf('SYS_ADMIN') == -1 && this.state.access.indexOf('BUSINESS_OWNER') != -1 ||  this.state.access.indexOf('COACH') != -1)? <this.MenuLink linkTo="/pokerwatchteam" label="Poker Watch" />
            : null
          }
          {this.state.access.indexOf('SYS_ADMIN') !== -1 ?
            <div>
              <this.MenuLink linkTo="/appUserComp" label="Users" />
              <this.MenuLink linkTo="/tournamenttype" label="Tournament Type" />
              <this.MenuLink linkTo="/tournamentwatch" label="Tournament Watch (MTT)" />
            </div>
            : null
          }
          {this.state.access.indexOf('SYS_ADMIN') !== -1 ?
            <div>
              <this.MenuLink linkTo="/businessList" label="Business Master" />
              <this.MenuLink linkTo="/promotionalContent/list" label="Promotional Content" />
              <this.MenuLink linkTo="/moduleNlessonList" label="Modules/Lessons" />
              <this.MenuLink linkTo="/newContent" label="Lesson Content" />
            </div>
            : null
          }
          {this.state.access.indexOf('PLAYER') !== -1 ?
            <this.MenuLink linkTo="/myReportCard" label="Report Card" />
            : null
          }
          {this.state.access.indexOf('SYS_ADMIN') != -1 || this.state.access.indexOf('SHIFT_MANAGER') != -1 || this.state.access.indexOf('PLAYER') != -1 || this.state.access.indexOf('COACH') != -1 ?
            <this.MenuLink linkTo="/course" label="Courses" />
            : null
          }
          {(this.state.userType === 'myGame' || this.state.access.indexOf('SYS_ADMIN') != -1 || this.state.access.indexOf('BUSINESS_OWNER') != -1)
            ? <this.MenuLink linkTo="/changePwd" label="Change Password" />
            : null
          }
          {(this.state.userType === 'myGame' || this.state.access.indexOf('SYS_ADMIN') != -1)
            ? <this.MenuLink linkTo="/teamCreation" label="Bulk Team Creation" />
            : null
          }

          <this.MenuLink linkTo="#" onLinkClick={this.logout} label="Log Out" />
        </div>
      </Drawer>
    )
  }
  openPopUp = () =>{
    let track = {}
    track.hit_page = 'ExportHandsPopup';
    track.hit_type = 'OpenModal';
    saveActivity(track);
  }

  changeLanguage = (event) =>{
    let lang = event.target.value;
    localStorage.setItem('new_language', lang);
    if(window.location.pathname=='/SkillLevel') {
        this.props.getMultiReportCardDeatils(this.props.reportCardSetting)
    }else {
      this.props.getSingleReportCardsDetails(this.props.reportCardSetting[0]);
    }

    this.changei8next(lang);
  }

  changei8next = (lang) =>{
    i18next.changeLanguage(lang,()=>{
      this.props.changeLanguage({lang:lang});
      this.setState({lang:lang});
    });
  }

  

  onMGLClick = () => {
    console.log('window.location.hostname', window.location.hostname || 3001);
    if(this.state.wnd && !this.state.wnd.closed){
      this.state.wnd.focus();
    }else if(window.messageToNative || (window.external && window.external.NativeDispatch)){
      //for mac and vc clients
        DispatcherFunction("app:menu=3813&name=MYGAME_WHIZ",{
              "MYGAME_WHIZ_URL": 'https://' + window.location.hostname + '/liveview',
              "height": "670",
              "width": "350"
            })}
     else{
      let wnd = window.open('https://' + window.location.hostname +'/liveview', window.opener ? '_self' : '_blank', 'location=yes,height=670,width=350,scrollbars=yes,status=yes');
     this.setState({wnd})
     }
    let activityTrack = []
    let track = {}
    if (localStorage.getItem('activityTrack'))
      activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
    track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
    track.session_id = localStorage.getItem("token")
    track.userid = localStorage.getItem("username")
    track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
    track.hit_page = 'MyGame'
    track.hit_type = 'OpenPokerwhiz'
    track.hit_attribute1 = localStorage.getItem("loggedInType")
    track.hit_attribute2 = localStorage.getItem("first_name")
    track.hit_attribute3 = localStorage.getItem("last_name")
    track.hit_attribute4 = localStorage.getItem("alias")
    track.hit_attribute5 = ''
    activityTrack.push(track)
    localStorage.setItem('activityTrack', JSON.stringify(activityTrack))
  }

  toggleMessenger = (show) => {
    console.log("toggleMessenger...",show)
    this.setState({ openMessenger: show })
    this.handleClose()
  }

  render() {
    const themeColor = getColor()
    const themeTextColor = getTextColor()
    const themeHoverColor = getHoverColor()
    const themeDarkTextColor = getDarkTextColor()
    let PartyPokerIcon = getImage("/images/logo/", ".png")
    return (
      <div className='header-main'>
        {!["MyGame", "PartyPoker"].includes(localStorage.getItem("loggedInType")) && <style>
          {`
            .nav>li>a:hover, .nav>li>a:focus {\
              background-color: transparent;
            }\
            .navbar-nav>li>a, .menuText {\
              font-weight: 500;\
            }\
            `}
        </style>}
        <style>
          {`
            .m-input-moment .options button.is-active, .m-input-moment .btn-save, .dp_download_btn {\
              background-color: ${themeColor};\
              color: ${themeTextColor};\
              border-color: ${themeColor};\
            }\
            .m-input-moment .options button, .shareToMomentButton, .m-calendar .current-day, .m-time .time,
            .m-time .time-text, .m-time .separater, .dp_select_time_text {\
              color: ${themeDarkTextColor};\
              border-color: ${themeColor};\
            }\
            .m-calendar tbody td:hover, .mutireplayer_shareHandButton {\
              background-color: ${themeColor};\
              color: ${themeTextColor};\
              border-color: ${themeColor};\
            }\
             .u-slider-time .handle:after, .dp_select_time_btn, .dp_download_text   {
              color: ${themeTextColor};\
              border-color: ${themeColor};\
            }
            .mutireplayer_shareHandButton:hover {\
              background-color: #FFFFFF;\
              color: ${themeDarkTextColor};\
            }\
            .shareToMomentButton:hover {\
              background-color: ${themeHoverColor};\
            }\
          `}
        </style>
        {this.state.loginRedirect && (<Redirect to={this.state.location} />)}
        <nav className="headerBar navbar-fixed-top" >
          <div className='container'>
            <DownloadHandHistory />

            {(this.state.access.indexOf('SYS_ADMIN') != -1 || this.state.access.indexOf('SHIFT_MANAGER') != -1 || this.state.access.indexOf('BUSINESS_OWNER') != -1 || this.state.access.indexOf('COACH') !== -1 )
            ? <MyGameMessenger2 id="mygamemessenger" open={this.state.openMessenger} 
            data-toggle="modal" data-target="#mygamemessenger" 
            handleClose={e => {this.toggleMessenger(false)}} />:null}
            <div className={'navbar-collapse' + (this.state.fromClient? '_Client' : '')}>
              <Link to={`/home?${queryString.stringify({ isMygameLogoClick: true })}`} style={{ float: "left", marginLeft: "10px" }}>
                <img data-e2e="myGameLogo" src={PartyPokerIcon} style={{ width: partyBrands.includes(this.state.loggedInType) ? '12em' : '8em', paddingBottom: "5px" }} />
              </Link>
              {this.state.access.indexOf('SYS_ADMIN') != -1 || this.state.access.indexOf('SHIFT_MANAGER') != -1 || this.state.access.indexOf('BUSINESS_OWNER') != -1 || this.state.access.indexOf('COACH') != -1
                ? null
                : <MediaQuery maxWidth={991}>
                  <span className='header-bar' onClick={()=>{this.handleToggle()}}>
                    <i className="fa fa-bars" style={{ color: 'white', marginRight: "10px" }}></i>
                  </span>
                </MediaQuery>}
              {this.state.access.indexOf('SYS_ADMIN') != -1 || this.state.access.indexOf('SHIFT_MANAGER') != -1 || this.state.access.indexOf('BUSINESS_OWNER') != -1 || this.state.access.indexOf('COACH') !== -1
                ? <span  className='header-bar admin-header' onClick={()=>{this.handleToggle()}}>
                  <i className="fa fa-bars" data-e2e="showMenu" style={{ color: 'white', marginRight: "10px" }}></i>
                </span>
                : <MediaQuery minWidth={992}>
                  <ul className="nav navbar-nav navbar-right">
                    {
                    //  localStorage.getItem("loggedInType") === "Danskespil"
                    //   ? <li className='HeaderMenu' data-e2e="pokerwize" onClick={()=>{this.onMGLClick()}}> <a style={{ background: 'none',padding:"0px 4px",lineHeight: "50px"}}>Whiz</a></li>
                    //  : 
                     <li className='HeaderMenu' data-e2e="pokerwize" onClick={()=>{this.onMGLClick()}}> <a style={["MyGame", "PartyPoker"].includes(localStorage.getItem("loggedInType")) ? {
                      background: '#E62017',  
                      marginTop: '10px',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        padding:"0px 6px",
                        lineHeight: "32px"
                      } : {
                        marginTop: '10px',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        padding:"0px 6px",
                        lineHeight: "32px"
                       }}>Whiz</a></li>
                    }
                    <li className='HeaderMenu'><Link to="/SkillLevel?logintype=player" style={{ background: 'none', padding: "0px 4px", lineHeight: "50px" }} data-e2e="skill-level"> {
                    // localStorage.getItem("loggedInType") === "Danskespil" ? "Report Cards" :
                    i18next.t("lable.reportCards")}</Link></li>
                    <li className='HeaderMenu'><Link to="/MyStatistics?logintype=player" style={{ background: 'none',padding:"0px 4px",lineHeight: "50px" }} data-e2e="mystatistics">{i18next.t("lable.myStatistics")}</Link></li>
                    <li className='HeaderMenu'><Link to="/MyHands" style={{ background: 'none',padding:"0px 4px",lineHeight: "50px" }}data-e2e="myHands">{i18next.t("lable.myHands")}</Link></li>
                    {/* {localStorage.getItem("loggedInType") === "Danskespil" ? <li className='HeaderMenu'><Link data-e2e="course" to="/course" style={{ background: 'none' }}>Courses</Link></li> : null } */}
                    <li className='HeaderMenu' data-e2e="menu-exportHadns-link"  data-toggle="modal"
                      data-target="#downloadModal"><a onClick={this.openPopUp} style={{ background: 'none', paddingRight:'1px', paddingLeft:'1px' }} data-e2e="exporthands">{i18next.t("lable.exportHands")}
                      {
                      ["MyGame", "PartyPoker"].includes(localStorage.getItem("loggedInType")) ?
                      <span className="glyphicon glyphicon-download-alt" style={{ color: "#E62017" }} ></span>
                    : null}
                    </a></li>
                    {
                    // localStorage.getItem("loggedInType") === "Danskespil" ? null : 
                    //<li className='HeaderMenu'><Link data-e2e="course" to="/course" style={{ background: 'none', paddingLeft:'2px', paddingRight:'3px' }}>{i18next.t("lable.courses")}</Link></li>
                    (!(window.messageToNative || (window.external && window.external.NativeDispatch)))?<li className='HeaderMenu'><Link data-e2e="course" to="/course" style={{ background: 'none', paddingLeft:'2px', paddingRight:'3px' }}>{i18next.t("lable.courses")}</Link></li>:
                    <li className='HeaderMenu'><a style={{backgroundColor:"#080808"}} onClick={()=>{
                      if (window.messageToNative || (window.external && window.external.NativeDispatch)) {
                        //for mac and vc clients
                        DispatcherFunction("app:menu=3812&name=MYGAME_COURSES",{"MYGAME_COURSES_URL":'https://' +window.location.hostname +'/course'})
                      }
                    }}>{i18next.t("lable.courses")}</a></li>
                    }
                    {this.state.access.indexOf('PLAYER') !== -1
                      ? 
                      this.state.fromClient?null:<li className='HeaderMenu'><Link data-e2e="playerLogout" to="#" style={{ background: 'none',padding:"0px 4px",lineHeight: "50px"}} data-e2e="LogOut" onClick={() => { this.resetStore() }}>{i18next.t("lable.logOut")}</Link></li>

                      : <li className='HeaderMenu dropdown'>
                        <Link data-e2e="playerAcc" to="#" data-toggle="dropdown" className="dropdown-toggle" style={{ background: 'none', paddingRight: 0 }}> {i18next.t("lable.account")} <i className="fa fa-angle-down" style={{ fontWeight: 'bold' }}></i></Link>
                        <ul className="dropdown-menu" style={{ width: '134%' }}>
                          {this.state.userType === 'myGame'
                            ? <li style={{ height: '40px', lineHeight: '40px' }}><Link to="/changePwd" style={{ textAlign: 'center', fontWeight: 'bold', lineHeight: '33px' }} >{i18next.t("lable.changePassword")}</Link></li>
                            : null}
                          {this.state.userType === 'myGame'
                            ? <li style={{ height: '40px', lineHeight: '40px' }}><Link to="/teamCreation" style={{ textAlign: 'center', fontWeight: 'bold', lineHeight: '33px' }} >{i18next.t("lable.bulkTeamCreation")}</Link></li>
                            : null}
                          <li style={{ height: '40px', lineHeight: '40px' }}><Link data-e2e="playerLogout" to="#" style={{ textAlign: 'center', fontWeight: 'bold', lineHeight: '33px' }} onClick={() => { this.resetStore() }}>{i18next.t("lable.logOut")}</Link></li>
                        </ul>
                      </li>
                    }
                    {/* {this.state.disableLangauge === 'off' &&<li>
                     <select className="dropdaown-langauge form-control" onChange={this.changeLanguage} value={this.state.lang} >
                        <option value="en">English</option>
                        <option value="fr">French</option>
                    </select>
                    </li>} */}
                  </ul>
                </MediaQuery>}
            </div>
          </div>
        </nav>
        <Drawer containerStyle={{ backgroundColor: '#222222' }} open={this.state.open} openSecondary={true} docked={false} onRequestChange={(open) => this.setState({ open })}>
          <MediaQuery maxWidth={991}>
            <span className='header-cross-bar' onClick={(open) => this.setState({ open: false })}>
              <i className="fa fa-close" style={{ color: 'white', float: 'right', marginRight: '57%' }}></i>
            </span>
          </MediaQuery>
          <div style={{ marginTop: '66px' }}>

            {(this.state.access.indexOf('SYS_ADMIN') != -1) ?
              <div>
                <MenuItem onClick={() => this.toggleMessenger(true)} 
                 data-toggle="modal" data-target="#mygamemessenger"
                style={{ textAlign: 'center', textDecoration: 'none' }}>
                  
                  <span className='menuText' data-e2e="menu-my-account"  >MyGameMessenger</span>
                </MenuItem>
              </div> : null}
              {(this.state.access.indexOf('SYS_ADMIN') != -1 || this.state.access.indexOf('BUSINESS_OWNER') != -1 || this.state.access.indexOf('COACH') != -1 )?
          <div>
            
                <Link to="/myaccount" style={{ textAlign: 'center', textDecoration: 'none', borderBottomStyle: 'double', borderBottomColor: 'white', borderBottomWidth: '5px' }}>
                  <MenuItem onClick={()=>{this.handleClose()}}><span className='menuText'data-e2e="menu-my-account">My Account</span></MenuItem>
                </Link>
              </div>:null}
            {(this.state.access.indexOf('SYS_ADMIN') != -1 || this.state.access.indexOf('BUSINESS_OWNER') != -1 || this.state.access.indexOf('COACH') != -1 )
              ? this.state.access.indexOf('SYS_ADMIN') != -1 || this.state.access.indexOf('BUSINESS_OWNER') != -1 ?<div>
                <Link to="/pokerwatch" style={{ textAlign: 'center', textDecoration: 'none', borderBottomStyle: 'double', borderBottomColor: 'white', borderBottomWidth: '5px' }}>
                  <MenuItem onClick={()=>{this.handleClose()}}><span className='menuText'data-e2e="menu-pokerwatch">Poker Watch</span></MenuItem>
                </Link>
              </div>:<Link to="/pokerwatchteam" style={{ textAlign: 'center', textDecoration: 'none', borderBottomStyle: 'double', borderBottomColor: 'white', borderBottomWidth: '5px' }}>
                  <MenuItem onClick={()=>{this.handleClose()}}><span className='menuText'data-e2e="menu-pokerwatch">Poker Watch</span></MenuItem>
                </Link>
              : null}
            {this.state.access.indexOf('SYS_ADMIN') !== -1 
              ? <div>
                <Link to="/appUserComp" style={{ textAlign: 'center', textDecoration: 'none' }}>
                  <MenuItem onClick={()=>{this.handleClose()}} ><span className='menuText' data-e2e="menu-user">Users</span></MenuItem>
                </Link>
                <Link to="/tournamenttype" style={{ textAlign: 'center', textDecoration: 'none' }}>
                  <MenuItem onClick={()=>{this.handleClose()}} ><span className='menuText' data-e2e="tournment-type">Tournament Type</span></MenuItem>
                </Link>
                <Link to="/tournamentwatch" style={{ textAlign: 'center', textDecoration: 'none' }}>
                  <MenuItem data-e2e="tournamentWatchClick" onClick={()=>{this.handleClose()}}><span className='menuText' data-e2e="tournment-watch">Tournament Watch (MTT)</span></MenuItem>
                </Link>
              </div>
              : null}
            {this.state.access.indexOf('SYS_ADMIN') !== -1  || this.state.access.indexOf('BUSINESS_OWNER') != -1
              ? <div>
                <Link to="/businessList" style={{ textAlign: 'center', textDecoration: 'none' }}>
                  <MenuItem onClick={()=>{this.handleClose()}} ><span className='menuText' data-e2e="business-master">Business Master</span></MenuItem>
                </Link>
                <Link to="/promotionalContent/list" style={{ textAlign: 'center', textDecoration: 'none' }}>
                  <MenuItem onClick={()=>{this.handleClose()}}><span className='menuText' data-e2e="promotional-content">Promotional Content</span></MenuItem>
                </Link>
                <Link to="/moduleNlessonList" style={{ textAlign: 'center', textDecoration: 'none' }}>
                  <MenuItem onClick={()=>{this.handleClose()}}><span className='menuText' data-e2e="module-lessons">Modules/Lessons</span></MenuItem>
                </Link>
                <Link to="/newContent" style={{ textAlign: 'center', textDecoration: 'none' }}>
                  <MenuItem onClick={()=>{this.handleClose()}}><span className='menuText' data-e2e="lesson-content">Lesson Content</span></MenuItem>
                </Link>
              </div>
              : null}

              {this.state.access.indexOf('PLAYER') !== -1
              ? <span>
                <div>
                  {/* <Link style={{textAlign:'center',textDecoration:'none'}}> */}
                  { 
                  // localStorage.getItem("loggedInType") === "Danskespil"
                  //   ? <MenuItem style={{ textAlign: 'center', textDecoration: 'none' }}  data-e2e="pokerwize" onClick={this.onMGLClick} ><span className='menuText' data-e2e="pokerwhiz">Whiz</span></MenuItem>
                  //   : 
                    <MenuItem style={{ textAlign: 'center', textDecoration: 'none' }} data-e2e="pokerwize" onClick={this.onMGLClick} ><span className='menuText' style={["MyGame", "PartyPoker"].includes(localStorage.getItem("loggedInType")) ? {
                      background: '#E62017',
                      padding: '7px 15px',
                      borderRadius: '5px',
                      cursor: 'pointer'
                    } : {
                      padding: '7px 15px',
                      borderRadius: '5px',
                      cursor: 'pointer'
                    }
                    } data-e2e="pokerwhiz">Whiz</span></MenuItem>
                  }
                  {/* </Link> */}
                </div>
                  <Link to="/SkillLevel?logintype=player" style={{ textAlign: 'center', textDecoration: 'none' }}>
                  <MenuItem onClick={() => { this.handleClose() }} ><span className='menuText'>
                    {
                    // localStorage.getItem("loggedInType") === "Danskespil" ? "Report Cards" :
                    i18next.t("lable.reportCards")}</span></MenuItem>
                  </Link>
                  <Link to="/MyStatistics?logintype=player" style={{ textAlign: 'center', textDecoration: 'none' }}>
                    <MenuItem onClick={()=>{this.handleClose()}} ><span className='menuText'>{i18next.t("lable.myStatistics")}</span></MenuItem>
                  </Link>
                  <Link to="/MyHands" style={{ textAlign: 'center', textDecoration: 'none' }}>
                    <MenuItem onTouchTap={this.handleClose} ><span className='menuText' data-e2e="myHands">{i18next.t("lable.myHands")}</span></MenuItem>
                  </Link>
              </span>
              : null}

            {/* {localStorage.getItem("loggedInType") === "Danskespil" && (this.state.access.indexOf('SYS_ADMIN') != -1 || this.state.access.indexOf('SHIFT_MANAGER') != -1 || this.state.access.indexOf('PLAYER') != -1 || this.state.access.indexOf('COACH') !== -1)
              ?
              <div>
                <Link to="/course" style={{ textAlign: 'center', textDecoration: 'none' }}>
                  <MenuItem onClick={()=>{this.handleClose()}}><span className='menuText' data-e2e="menu-courses" >Courses</span></MenuItem>
                </Link>
              </div>
              : null} */}
            {this.state.access.indexOf('PLAYER') !== -1
              ? <span>
                  <a onClick={this.openPopUp} data-e2e="menu-exportHadns-link"  data-toggle="modal"
                    data-target="#downloadModal" style={{ textAlign: 'center', textDecoration: 'none' }}>
                    <MenuItem onClick={()=>{this.handleClose()}} ><span className='menuText'>{i18next.t("lable.exportHands")} 
                    {
                      ["MyGame", "PartyPoker"].includes(localStorage.getItem("loggedInType")) ?
                        <span className="glyphicon glyphicon-download-alt" style={{ color: "#E62017" }} ></span>
                        : null}
                     </span></MenuItem>
                  </a>
              </span>
              : null}
              {/* {this.state.disableLangauge === 'off' && <select className="form-control dropdaown-langauge" onChange={this.changeLanguage} value={this.state.lang} >
                        <option value="en">English</option>
                        <option value="fr">French</option>
                    </select>} */}
            {
            // localStorage.getItem("loggedInType") !== "Danskespil" && 
            (this.state.access.indexOf('SYS_ADMIN') != -1 ||  this.state.access.indexOf('BUSINESS_OWNER') != -1 || this.state.access.indexOf('SHIFT_MANAGER') != -1 || this.state.access.indexOf('PLAYER') != -1)
              ?
              <div>
                <Link to="/course" style={{ textAlign: 'center', textDecoration: 'none' }}>
                  <MenuItem onClick={()=>{this.handleClose()}}><span className='menuText' data-e2e="menu-courses" >{i18next.t("lable.courses")}</span></MenuItem>
                </Link>
              </div>
              : null}
            {/* {(this.state.userType === 'myGame' || this.state.access.indexOf('SYS_ADMIN') != -1 || this.state.access.indexOf('BUSINESS_OWNER') != -1)
              ? <Link to="/changePwd" style={{ textAlign: 'center', textDecoration: 'none', fontSize: '14px' }}>
                <MenuItem onClick={()=>{this.handleClose()}}><span className='menuText'>Change Password</span></MenuItem>
              </Link>
              : null} */}
                {(this.state.userType === 'myGame' || this.state.access.indexOf('SYS_ADMIN') != -1 )
              ? <Link to="/teamCreation" style={{ textAlign: 'center', textDecoration: 'none', fontSize: '14px' }}>
                <MenuItem onClick={()=>{this.handleClose()}}><span className='menuText'> {i18next.t("lable.bulkTeamCreation")} </span></MenuItem>
              </Link>
              : null}
            {
              this.state.fromClient ? null : <Link to="#" style={{ textAlign: 'center', textDecoration: 'none', fontSize: '14px' }} onClick={this.resetStore}>
                <MenuItem onClick={() => { this.handleClose() }}><span data-e2e="logout" className='menuText' data-e2e="menu-logout">{i18next.t("lable.logOut")}</span></MenuItem>
              </Link>
            }
          </div>
        </Drawer>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    title: state.header.title,
    lang: state.header.lang,
    reportCardSetting: state.multipleReportCards.reportCardSetting,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetStore: () => dispatch(actions.resetStore()),
    changeLanguage: (lang)=>dispatch(actions.changeLanguage(lang)),
    getMultiReportCardDeatils: (playeReoprtDtls) => dispatch(actions.getMultiReportCardDeatils(playeReoprtDtls)),
    getSingleReportCardsDetails: (reportCardSetting) => dispatch(actions.getSingleReportCardsDetails(reportCardSetting)),
  }
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);



/** WEBPACK FOOTER **
 ** ./src/container/Header/Header.js
 **/